import React from 'react'
import { observer } from 'mobx-react'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentTitle,
  ModalSheetContentDescription,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
  ModalSheetContentBlock,
} from 'components/ModalSheet'
import Button from 'components/Button'
import TextInput from 'components/inputs/TextInput'
import CreateJobConfirmationDialogViewModel from './CreateJobConfirmationDialogViewModel'

interface Props {
  vm: CreateJobConfirmationDialogViewModel
}

export default observer(function CreateJobConfirmationDialog({ vm }: Props) {
  const isInitializing = vm.confirm.pending

  return (
    <ModalSheet showing={vm.showing} onRequestClose={vm.close}>
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <ModalSheetContentTitle>Confirm job creation</ModalSheetContentTitle>
        <ModalSheetContentDescription>
          Are you sure you want to create a job for{' '}
          <strong>{vm.memberName}</strong> in{' '}
          <strong>{vm.workspaceName}</strong>?
        </ModalSheetContentDescription>
        <ModalSheetContentDescription compact>
          Type the workspace name to continue.
        </ModalSheetContentDescription>
        <ModalSheetContentBlock expanded>
          <TextInput
            value={vm.confirmationInput}
            onChange={(event) => vm.setInput(event.target.value)}
            onPaste={(event) => event.preventDefault()}
            onDrop={(event) => event.preventDefault()}
            autoFocus
          />
        </ModalSheetContentBlock>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button type="default" onClick={vm.close}>
            Cancel
          </Button>
          <Button
            type="primary"
            onClick={vm.confirm}
            disabled={!vm.canConfirm || isInitializing}
            loading={isInitializing}
          >
            Create job
          </Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})
